
import Tabs from '@/components/Tabs';
import DigitalCapacity from '@/components/Hall/DigitalCapacity';
import hum from 'humanize-duration';
import Vlogin from '../../components/popUp';
import api from '../../api';
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import Vagreement from './agreement'
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'


export default {
name: 'confirmApplication',
components: { Tabs, DigitalCapacity, Vlogin, CheckIcon, Vagreement, XButton},
mounted() {
const id = this.$route.query.id;
this.defaultManID = this.$route.query.defaultManID;
if (id) {
this.id = id;
this.getDtail();
if (this.isLogin) {
this.getQualificationState();
}
}
this.getDefaultContact()
this.defaultManID && this.getContact()




















},
data: () => ({
nowDate: new Date(),
isEnd: false,
qState: {}, // 招标单车队报名资质认证状态
id: '',
detailData: {},
certificateOptions: [
{ label: '营业执照（三证合一）', value: '2' },
{ label: '道路运输许可证', value: '3' },
{ label: '开户许可证', value: '4' },
{ label: '年度货物运输险', value: '5' },
],
carrierState: 0, // 当前登录用户与招标单的关系状态
readme: true,
areementVisible: false,
defaultManID: null,
defaultMan: {}
}),
computed: {
allDic() {
return this.$store.state.allDic;
},
isLogin() {
return this.$store.state.isLogin;
},
},
methods: {
getDefaultContact() {
api.vega.contact.listContacts({
pageNo: 1,
pageSize: 100,
}).then((res) => {
const data = res.data.data.result;
data.map((item) => {
if (item.status === 1) {
this.defaultMan = item;
}
});
});
},
getContact () {
api.vega.contact.getContact({
id: this.defaultManID,
}).then((res) => {
this.defaultMan = res.data.data
});
},
getDtail() {
api.vega.tender.detail({
tenderId: this.id,
}).then((res) => {
const data = res.data.data;
this.detailData = data;
this.carrierState = data.carrierState;
});
},
goodsType(type) {
let goodsType = '--';
if (this.allDic['goodsType']) {
this.allDic['goodsType'].children.map((item) => {
if (`${type}` === item.id) {
goodsType = item.value;
}
return item;
})
}
return goodsType;
},
findRate(str) {
const strArr = [];
if (str) {
const arr = str.split(',');
for (let i = 0; i < arr.length; i++) {
const item = `${parseFloat(arr[i], 10) * 100}%`;
strArr.push(item);
}
}
return strArr.join('，');
},
findRequired(str) { // 查询证件要求
if (str) {
const arr = str.split(',');
const arr2 = [];
for (let i = 0; i < arr.length; i++) {
const item = arr[i];
for (let j = 0; j < this.certificateOptions.length; j++) {
const _item = this.certificateOptions[j];
if (item === _item.value) {
arr2.push(_item.label);
}
}
}
return arr2.join('，');
}
},
leftTime(time = '') {
let diff = '';
const end = new Date(time.replace(/-/g, '/'));
diff = Math.floor((end.getTime() - this.nowDate.getTime()) / 1000);
if (diff <= 0) {
this.isEnd = true;
} else if (diff > 0) {
this.isEnd = false;
}
return this.getLeveTime(diff);
},
getLeveTime(r) {
let t = '';
if (r - 0 === 0) {
return 0;
}
if (r) {
t = hum(r * 1000, {
language: 'zh_CN',
delimiter: ' ',
largest: 2,
}).replace(/\s/g, '');
}
return t;
},
getQualificationState() {
api.vega.tender.qualificationState({ id: this.id }).then((res) => {
const data = res.data.data;
this.qState = data;
})
},
signUp() {
this.$router.push({
name: 'hall.selectContact',
query: {
id: this.id,
}
})
},
save() {
if (!this.isLogin) {
this.$vux.toast.text('请先登录');
this.$store.commit('updateIsPopLogin', true);
return;
}
if (this.isEnd) {
return;
}
const { businessPaperState, transportPaperState, accountPaperState, regAmountState, regYearsState, taxrateState, insurancePaperState } = this.qState;
if ((regAmountState !==0 && regAmountState === 2) || regAmountState === 3) {
this.$vux.toast.text('抱歉, 您的注册资金未通过');
return;
}
if ((regYearsState !==0 && regYearsState === 2) || regYearsState === 3) {
this.$vux.toast.text('抱歉, 您的注册年限未通过');
return;
}
if ((businessPaperState !==0 && businessPaperState === 2) || businessPaperState === 3) {
this.$vux.toast.text('营业执照（三证合一）不通过,请完善资质');
return;
}
if ((transportPaperState !==0 && transportPaperState === 2) || transportPaperState === 3) {
this.$vux.toast.text('道路运输许可证 不通过,请完善资质');
return;
}
if ((accountPaperState !==0 && accountPaperState === 2) || accountPaperState === 3) {
this.$vux.toast.text('开户许可证 不通过,请完善资质');
return;
}
if ((taxrateState !==0 && taxrateState === 2) || taxrateState === 3) {
this.$vux.toast.text('发票要求 不通过,请完善资质');
return;
}
if ((insurancePaperState !==0 && insurancePaperState === 2) || insurancePaperState === 3) {
this.$vux.toast.text('年度货物运输险 不通过,请完善资质');
return;
}
if (JSON.stringify(this.defaultMan) === '{}') {
this.$vux.toast.text('请选择联系人！');
return;
}
const params = {
tenderId: this.id,
contactId: this.defaultMan.id,
contactsName: this.defaultMan.name,
contactsEmail: this.defaultMan.mail,
contactsPhone: this.defaultMan.mobile,
contactsTel: this.defaultMan.tel
}
api.vega.tender.signUp(params).then((res) => {
const code = res.data;
const _this = this;
if (code.code === 0 && code.sub_code === 0) {
this.$router.push({
name: 'hall.signUpSuccess',
})
}
})
},
},
};
